import { API } from 'aws-amplify';
import { getLatestJwtToken } from 'services/amplify-auth';

const getHeaders = async () => {
  const token = await getLatestJwtToken();
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
  return requestConfig;
};

export const getNotificationsRow = async (notify: (notification: any) => any): Promise<NotificationRow[]> => {
  return await API.get(
    'orderful-api',
    '/notifications/all',
    await getHeaders()
  )
    .then(notifications => {
      return notifications;
    })
    .catch(err => {
      notify({
        variant: 'error',
        message: `Error getting rows`
      });
      console.log(err);
    });
};

export const AddNotificationRow = async (
  notification: NotificationRow,
  notify: (notification: any) => any
) => {
  return await API.post('orderful-api', '/notifications/add', {
    body: notification,
    ...(await getHeaders())
  })
    .then(notifications => {
      notify({
        variant: 'success',
        message: 'Added notification'
      });
      return notifications;
    })
    .catch(err => {
      notify({
        variant: 'error',
        message: `Error adding notification`
      });
    });
};

export const UpdateNotificationRow = async (
  notification: NotificationRow,
  notify: (notification: any) => any
) => {
  return await API.put('orderful-api', '/notifications/update', {
    body: notification,
    ...(await getHeaders())
  })
    .then(notifications => {
      notify({
        variant: 'success',
        message: 'Updated notification'
      });
      return notifications;
    })
    .catch(err => {
      notify({
        variant: 'error',
        message: `Error updating notification`
      });
    });
};

export const DeleteNotificationRow = async (
  id: number,
  notify: (notification: any) => any
) => {
  await API.del('orderful-api', `/notifications/remove/${id}`, {
    ...(await getHeaders())
  })
    .then(notifications => {
      notify({
        variant: 'success',
        message: 'Removed notification'
      });
    })
    .catch(err => {
      notify({
        variant: 'error',
        message: `Error removing notification`
      });
    });
};